import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { DiamondIcon, InfoIcon, WarningIcon } from '@experimental-components/IconsComponents/FeedBackBanner';

import theme from 'utils/theme';

import useStyles from './styles';

type FeedbackBannerType = 'error' | 'warning' | 'info';
interface FeedbackBannerProps {
  title?: string;
  description?: string | React.ReactNode;
  type: FeedbackBannerType;
}

export function FeedbackBanner({ title, description, type }: FeedbackBannerProps) {
  const classes = useStyles();

  const icon = {
    error: <DiamondIcon size={24} />,
    warning: <WarningIcon size={24} />,
    info: <InfoIcon size={24} />,
  };

  const color = {
    error: theme.palette.error.main,
    warning: theme.palette.warning.main,
    info: theme.palette.info.main,
  };

  return (
    <Box
      alignItems="center"
      className={clsx(classes.feedbackBanner, classes[type as FeedbackBannerType])}
      display="flex"
      sx={{
        backgroundColor: color[type as FeedbackBannerType],
        border: `1px solid ${color[type as FeedbackBannerType]}`,
      }}
      width="100%"
    >
      <Box sx={{ width: 24, height: 24 }}>{icon[type as FeedbackBannerType]}</Box>

      <Box alignItems="center" display="inline-flex" fontWeight="fontWeightMedium" gap="0.5rem">
        {title && (
          <Typography
            color={color[type as FeedbackBannerType]}
            sx={{
              fontSize: 14,
            }}
          >
            {title}
          </Typography>
        )}

        <Typography
          sx={{
            fontSize: 14,
            color: '#47465F',
            '& strong': {
              fontWeight: 500,
            },
          }}
          variant="body1"
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
